import { render, staticRenderFns } from "./StudipIdentImage.vue?vue&type=template&id=a0f4b464&scoped=true&"
import script from "./StudipIdentImage.vue?vue&type=script&lang=js&"
export * from "./StudipIdentImage.vue?vue&type=script&lang=js&"
import style0 from "./StudipIdentImage.vue?vue&type=style&index=0&id=a0f4b464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f4b464",
  null
  
)

export default component.exports